import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useInvalidateExternalApiToken(options?: UseMutationOptions<void, unknown, void>) {
  return useMutation({
    mutationFn: async () => {
      const api = getPrivateApi();

      await api.invalidateExternalApiToken();
    },
    ...options,
  });
}
